import { all, fork } from 'redux-saga/effects';
import appSaga from '../features/App/App.saga';
import ProfileSaga from '../features/Profile/Profile.saga';
import spaceSaga from '../features/Spaces/Spaces.saga';
import usersSaga from '../features/Users/Users.saga';
import GroupSaga from '../features/Groups/Groups.saga';
import AchievementsSaga from '../features/Achievements/Achievements.saga';
import SiteOwnerTestResultsSaga from '../features/SiteOwnerTestResults/SiteOwnerTestResults.saga';
import QuestionnairesSaga from '../features/Questionnaires/Questionnaires.saga';
import SettingsSaga from '../features/Settings/Settings.saga';

export default function* rootSaga() {
  yield all([
    fork(appSaga),
    fork(spaceSaga),
    fork(usersSaga),
    fork(ProfileSaga),
    fork(GroupSaga),
    fork(AchievementsSaga),
    fork(SiteOwnerTestResultsSaga),
    fork(QuestionnairesSaga),
    fork(SettingsSaga),
  ]);
}
